import React from 'react'
import Navbar from '../Navbar/Navbar'
import NewProducts from './NewProducts'
import Footer from '../Footer/Footer'

export default function Prod_Foot() {
  return (
    <div>
      <Navbar/>
      <NewProducts/>
      <Footer/>
    </div>
  )
}
